import React, { Component } from 'react';
import Button from 'material-ui/Button';
import { withStyles } from 'material-ui/styles';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import TextField from 'material-ui/TextField';

import Dialog, {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from 'material-ui/Dialog';

import * as InspectionActions from '../../inspection/inspection.actions';
import * as ReportsActions from '../reports.actions';
import { getCurrentUser } from '../../user/user.selectors';

const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 150,
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2,
  },
  hide: {
    display: 'none',
  },
});

class WorkorderConfirm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      submitted: false,
      review: false,
      submitSuccess: false,
      sendTo: "",
      validatedEmails: [],
      emailHeader: "Työtilaus",
      emailMessage: "",
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.workorderSerialnumbers !== prevProps.workorderSerialnumbers) {
      const serials = this.props.workorderSerialnumbers
      let newHeader = "Työtilaus"
      if(serials.length) newHeader = newHeader+' - '+serials.toString().replace(/,/g,', ')
      this.setState({
        emailHeader: newHeader,
      });
    }
  }

  handleCancel = () => {
    this.props.onRequestClose();
    this.setState({
      submitted: false,
      review: false,
      submitSuccess: false,
    });
  };

  handlesendToChange = (event) => {
    // eslint-disable-next-line
    const regex = RegExp(/(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/g);
    const validEmails = event.target.value.match(regex) ? event.target.value.match(regex) : []
    
    this.setState({
      validatedEmails: validEmails, 
      sendTo: event.target.value,
    });
  };

  handleEmailHeaderChange = (event) => {
    this.setState({
      emailHeader: event.target.value,
    });
  };

  handleEmailMessageChange = (event) => {
    this.setState({
      emailMessage: event.target.value,
    });
  };

  handleReview = () => {
    this.setState({
      review: !this.state.review,
    });
  };

  handlePrint = () => {
    const { sendWorkorder, reports } = this.props;
    const { validatedEmails, emailHeader, emailMessage } = this.state;
    sendWorkorder(reports, validatedEmails, emailHeader, emailMessage)
      .then(action => {
        if (action && action.response && action.response.status === 'ok') {
          this.setState({
            submitted: true,
            submitSuccess: true,
          });
        } else {
          this.setState({
            submitted: true,
            submitSuccess: false,
          });
        }
      })
      .catch(error => {
        this.setState({
          submitted: true,
          submitSuccess: false,
        });
      });
  };

  userEmail = () => {
    const { currentUser } = this.props;
    if (currentUser) {
      return '(' + currentUser.email + ')';
    }
    return '';
  };

  renderRequest() {
    const { reports } = this.props;
    const { sendTo, emailHeader, emailMessage, validatedEmails } = this.state;
    const count = reports.length;
    return (
      <div>
        <DialogContent>
          <DialogContentText>
            Olet lähettämässä työtilauksen, jonka liitetiedostona on {count} raporttia?
          </DialogContentText>
          <TextField 
            label="Vastaanottajat"
            id="standard-required"
            placeholder="sahko.posti@osoite.fi, sahko.posti@osoite.fi, ..." 
            value={sendTo}
            onChange={this.handlesendToChange}
            margin="dense"
            fullWidth
          />
          <TextField 
            label="Otsikko"
            id="standard-required"
            value={emailHeader}
            onChange={this.handleEmailHeaderChange}
            margin="dense"
            fullWidth
          />
          <TextField
            label="Viesti"
            id="outlined-multiline-flexible"
            multiline
            rowsMax={10}
            value={emailMessage}
            onChange={this.handleEmailMessageChange}
            variant="outlined" 
            margin="dense"
            fullWidth
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleCancel}>Peruuta</Button>
          <Button 
            onClick={this.handleReview}
            color="primary"
            disabled={validatedEmails.length < 1}
          >
            Esikatselu
          </Button>
        </DialogActions>
      </div>
    );
  }

  renderReview() {
    const {validatedEmails, emailHeader, emailMessage} = this.state
    return (
      <div>
        <DialogContent>
          <DialogTitle id="preview-dialog-title">
            Esikatselu
          </DialogTitle>
          <DialogContentText>
            Työtilauksen vastaanottajat:
            {validatedEmails.map((email,index) => {
              return <span key={`email-${index}`}><br />{email.toString()}</span>
            })}
          </DialogContentText>
          <TextField 
            label="Sähköpostin otsikko"
            id="standard-required"
            value={emailHeader}
            margin="dense"
            fullWidth
            InputProps={{
              readOnly: true,
            }}
          />
          <TextField
            label="Saate viesti"
            id="outlined-multiline-flexible"
            multiline
            rowsMax={10}
            value={emailMessage}
            variant="outlined" 
            margin="dense"
            fullWidth
            InputProps={{
              readOnly: true,
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleCancel}>Peruuta</Button>
          <Button onClick={this.handleReview} color="primary">Takaisin</Button>
          <Button onClick={this.handlePrint} color="primary">
            Lähetä
          </Button>
        </DialogActions>
      </div>
    );
  }

  renderSuccess() {
    return (
      <div>
        <DialogContent>
          <DialogContentText>
            <span>Raportin luonti on aloitettu. Valmis paketti toimitetaan annettuihn
            sähköpostiosoitteisiin hetken kuluttua.</span>
            <br /><br />
            <span>Onnistuneen lähetyksen päätteeksi raportit merkataan lähetetyiksi.
            Tämä voi viedä muutaman minuutin ja vaatii sivun päivityksen.</span>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleCancel} color="primary">
            Ok
          </Button>
        </DialogActions>
      </div>
    );
  }

  renderFailure() {
    return (
      <div>
        <DialogTitle>Tulostus ei onnistu</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Työtilauksen lähettäminen ei onnistunut. Tarkista
            verkkoyhteytesi ja yritä myöhemmin uudelleen.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleCancel}>Sulje</Button>
        </DialogActions>
      </div>
    );
  }

  render() {
    const { open } = this.props;
    const { submitted, review, submitSuccess } = this.state;
    if (!open) {
      return null;
    }
    return (
      <Dialog onRequestClose={this.handleCancel} open={open}>
        {!submitted && !review
          ? this.renderRequest()
          : !submitted && review
            ? this.renderReview()
            : submitSuccess ? this.renderSuccess() : this.renderFailure()}
      </Dialog>
    );
  }
}

const mapStateToProps = state => {
  const currentUser = getCurrentUser(state);

  return {
    currentUser,
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    Object.assign({}, InspectionActions, ReportsActions)
  )(withStyles(styles)(WorkorderConfirm))
);



// WEBPACK FOOTER //
// ./src/modules/reports/components/WorkorderConfirm.js